import { Switch } from "@mui/material";
import React, { useEffect, useState } from "react";
import { UserType } from "../../../models/base/UserType";
import { userService } from "../../../services/userService";
import { useNotification } from "../../toster-notification/NotificationContext";
import { validateEmail } from "../../../utils/validators";

import { CloseGreyIcon } from "../../../assets/icons";
import { localService } from "../../../services/localService";
import { SelectLocalInfoDTO } from "../../../models/local/local.response";

interface AddOwnerViewProps {
    onClose: () => void;
}

const AddOwnerView: React.FC<AddOwnerViewProps> = ({ onClose }) => {

    const [locals, setLocals] = useState<SelectLocalInfoDTO[]>([]);

    const [fullName, setFullName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [emailError, setEmailError] = useState<string | null>(null);
    const [phone, setPhone] = useState<string>("");
    const [selectLocalId, setSelectLocalId] = useState<string>("");
    const [isActive, setIsActive] = useState<boolean>(true);
    const [userType, setUserType] = useState<UserType>(UserType.Admin);

    const { notify } = useNotification();
    const [loading, setLoading] = useState<boolean>(false);

    const userTypeOptions = [
        { value: UserType.Admin, label: "Admin" },
        { value: UserType.LocalWorker, label: "Radnik" }
    ];


    useEffect(() => {
        fetchLocals();
    }, []);


    const fetchLocals = async () => {
        setLoading(true);
        try {
            const response = await localService.getLocalsForSelect();

            if (response.data) {
                setLocals(response.data);
            } else {
                notify("error", "Failed to fetch locals.");
            }
        } catch (error) {
            console.error("Error fetching locals:", error);
            notify("error", "Failed to fetch locals.");
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        setEmailError(validateEmail(email))

        setEmailError("");

        try {
            let userData = {
                fullName,
                email,
                phone,
                userType,
                isActive,
                localId: userType === UserType.LocalWorker ? selectLocalId : undefined
            };

            const response = await userService.addUser(userData);

            if (response.success) {
                notify("success", response.message);
                onClose();
            } else {
                notify("error", response.message);
            }
        } catch (error: any) {
            notify("error", error.response.data.message);
            console.error("Error adding owner:", error);
        }
    }

    return (
        <section className="modal-section owner">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">Novi Vlasnik</div>
                                <div className="description-text">Dodajte novog vlasnika u sistem</div>
                            </div>
                            <div className="modal-button-div" onClick={onClose}>
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                            </div>
                        </div>
                        <div className="modal-form-block w-form">
                            <form className="modal-form">

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Ime i Prezime</label>
                                    <input
                                        className="form-input grey w-input"
                                        placeholder="Unesite ime i prezime"
                                        type="text"
                                        value={fullName}
                                        onChange={(e) => setFullName(e.target.value)}
                                    />
                                </div>

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Email *</label>
                                    <input
                                        className="form-input grey w-input"
                                        placeholder="Unesite email"
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <div className="email-text top-margin--5px">{emailError}</div>

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Telefon</label>
                                    <input
                                        className="form-input grey w-input"
                                        placeholder="Unesite telefon"
                                        type="tel"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                    />
                                </div>

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Tip Korisnika</label>
                                    <select
                                        className="form-select auto-width w-select"
                                        value={userType}
                                        onChange={(e) => setUserType(Number(e.target.value) as UserType)}
                                    >
                                        {userTypeOptions.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {userType === UserType.LocalWorker && (
                                    <div className="modal-form-div">
                                        <label className="modal-form-label">Lokacija</label>
                                        <select
                                            className="form-select auto-width w-select"
                                            value={selectLocalId}
                                            onChange={(e) => setSelectLocalId(e.target.value)}
                                        >
                                            <option value="" disabled>Izaberite lokaciju</option>
                                            {locals.map((local) => (
                                                <option key={local.id} value={local.id}>
                                                    {local.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}

                                <div className="modal-form-div f-horizontal">
                                    <label className="modal-form-label">Aktivan Nalog*</label>
                                    <div>
                                        <Switch
                                            checked={isActive}
                                            onChange={(e) => setIsActive(e.target.checked)}
                                        />
                                    </div>
                                </div>

                            </form>
                        </div>
                        <div className="modal-buttons">
                            <div className="button-secondary medium" onClick={onClose}>
                                <div>Otkaži</div>
                            </div>
                            <div className="button-primary medium" onClick={handleSubmit}>
                                <div>Dodaj vlasnika</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AddOwnerView;